import { postRequest } from './api';

const logLevels = ['info', 'warning', 'error'];

const logApi = {
  async createLog(data) {
    if (!data?.level || !logLevels.includes(data?.level)) {
      console.error(`Level is required and must be one of the following: ${logLevels.join(', ')}`);
      return;
    }
    if (!data?.message) {
      console.error('Message is required');
      return;
    }
    try {
      await postRequest('/api/logs', data);
    } catch (error) {
      console.error('Error creating log', error);
    }
  }
};

export default logApi;
